// Get Billing Credits Balance
export const GET_BILLING_CREDITS_BALANCE_REQUEST = 'GET_BILLING_CREDITS_BALANCE_REQUEST';
export const GET_BILLING_CREDITS_BALANCE_DONE = 'GET_BILLING_CREDITS_BALANCE_DONE';
export const GET_BILLING_CREDITS_BALANCE_FAILED = 'GET_BILLING_CREDITS_BALANCE_FAILED';
